import { mapState } from 'vuex';
import ExistingAbProductsComponent from '../../components/ExistingABProductsComponent.vue';
import { Options, Vue } from 'vue-class-component';
import { PropType } from 'vue';
import { CardBlock } from '@/cms/definitions/content-types';

@Options({
	name: 'PersonInfoStepComponent',
	props: {
		card: Object as PropType<CardBlock>,
		isValid: Boolean,
	},
	components: {
		ExistingAbProductsComponent,
	},
	computed: mapState<any>({
		model: (state) => state.calculatorContext[state.calculatorContext.active].model,
		cms: (state) => state.calculatorContext[state.calculatorContext.active].cms,
	}),
})
export default class PersonInfoStepComponent extends Vue {
	// card: CardBlock; // Card from cms
	// isValid: boolean; // whether card is complete
	// public model!: any; // data structure for user input (store)
	// public cms!: FamilySettings; // settings from CMS (store)
	// public defaultAddress: string = null;
	// public jaNejArray: Array<ValuePair> = jaNejArray;
	// public fieldValidator: FieldValidator = Validator;
	// public readonlyAge: string = null;
	// public readonlyFamilyMemberCount: string = null;
	// public created() {
	// 	const addressParam = this.$route.query.address as string;
	// 	if (addressParam) {
	// 		this.defaultAddress = addressParam;
	// 	}
	// }
	// public mounted() {
	// 	handleAddressPrefill(this.model.personInfo, this.cms);
	// 	this.readonlyAge = getCustomerReadonlyAge(this.model);
	// 	if (this.model.multipleProducts) {
	// 		const commonModel = store.getters.getCalculatorCommonModel;
	// 		if (commonModel.personInfo.familyMemberCount) {
	// 			this.readonlyFamilyMemberCount = this.model.personInfo.familyMemberCount;
	// 		}
	// 	}
	// 	addEventListener('keyup', this.moveOn);
	// }
	// public beforeUnmount() {
	// 	removeEventListener('keyup', this.moveOn);
	// }
	// public moveOn(evt) {
	// 	if (evt.keyCode === 13 && this.isValid) {
	// 		this.nextStep();
	// 	}
	// }
	// public nextStep() {
	// 	this.$emit('nextStep', this.card.routePath);
	// }
	// public async addressSearch(address) {
	// 	if (address?.matchText) {
	// 		await mapDawaAddress(this.model.personInfo, address);
	// 		copyAddress(this.model.personInfo, this.model.personInfo.homeAddress);
	// 		this.model.pristineStep.set(this.card.name, true);
	// 		return;
	// 	}
	// 	resetAddress(this.model.personInfo);
	// 	resetAddress(this.model.personInfo.homeAddress);
	// }
	// public familyMemberSelected(result: any) {
	// 	if (result && result.selectedValue) {
	// 		this.model.personInfo.familyMemberCount = result.selectedValue;
	// 		const inx = this.familyMemberList.indexOf(result.selectedValue);
	// 		this.model.personInfo.familyMemberCountId =
	// 			this.model.calculation.abCalc.familyMemberCountOptions[inx].value;
	// 		if (this.model.personInfo.familyMemberCountId < 2) {
	// 			setTimeout(() => {
	// 				const modal = modalWithExit(this.cms);
	// 				modal.title = 'Ingen børn i husstand';
	// 				modal.content =
	// 					'Du har oplyst at der er @personCount i jeres husstand. Ret venligst antal personer i jeres husstand, så alle personer er inkluderet'.replace(
	// 						'@personCount',
	// 						this.model.personInfo.familyMemberCount
	// 					);
	// 				modal.id = 'personCountError';
	// 				togglePopup(this.cms, modal);
	// 			}, 550);
	// 		}
	// 		return;
	// 	}
	// 	this.model.personInfo.familyMemberCount = undefined;
	// 	this.model.personInfo.familyMemberCountId = undefined;
	// }
	// get familyMemberList(): Array<string> {
	// 	const memberListFormatted = [];
	// 	this.model.calculation.abCalc.familyMemberCountOptions.forEach((element) => {
	// 		memberListFormatted.push(element.key);
	// 	});
	// 	return memberListFormatted;
	// }
	// public handleRadioClick(evt: any) {
	// 	const name = evt.name ?? evt.id;
	// 	if (name === 'thatchedRoof') {
	// 		this.model.personInfo.thatchedRoof = evt.value;
	// 		nextTick(() => {
	// 			// wait for transition to begin showing customerAge field
	// 			setTimeout(() => {
	// 				const input = document.getElementById('customerAge');
	// 				if (input) {
	// 					input.focus();
	// 				}
	// 			}, 300);
	// 		});
	// 	}
	// }
}
